var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[_vm.isGallery ? 'e3-folder green' : 'e3-folder orange', {'small': _vm.small, 'grid': _vm.isGrid}]},[(_vm.isReadonly)?_c('EyeIcon',{staticClass:"text-white-50",attrs:{"size":_vm.small ? 18 : 36}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }